// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3b_Je","list":"PatternAutocomplete_list__1FCFQ"};